module.exports = __webpack_public_path__ + "static/media/safety-batteries-2.34b7a5d0.png";